import { Box } from '@mui/material';
import React from 'react';
import { StyledTypography } from '../styles/styles';

interface EmailPreviewHeaderProps {
  to: string;
  subject: string;
}

const EmailPreviewHeader: React.FC<EmailPreviewHeaderProps> = ({ to, subject }) => (
  <>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        mb: 1.5,
      }}
    >
      <StyledTypography
        sx={{
          fontSize: '13px',
          color: '#666',
          fontWeight: 500,
          minWidth: '60px',
          flexShrink: 0,
        }}
      >
        To:
      </StyledTypography>
      <StyledTypography
        sx={{
          fontSize: '14px',
          color: '#143c34',
          wordBreak: 'break-word',
          flex: 1,
        }}
      >
        {to}
      </StyledTypography>
    </Box>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
      }}
    >
      <StyledTypography
        sx={{
          fontSize: '13px',
          color: '#666',
          fontWeight: 500,
          minWidth: '60px',
          flexShrink: 0,
        }}
      >
        Subject:
      </StyledTypography>
      <StyledTypography
        sx={{
          fontSize: '15px',
          color: '#143c34',
          fontWeight: 500,
          wordBreak: 'break-word',
          flex: 1,
        }}
      >
        {subject}
      </StyledTypography>
    </Box>
  </>
);

export default EmailPreviewHeader;
